import { ModelApiService } from './BaseApiService'

export default class ContactsApiService extends ModelApiService {
  constructor() {
    super('contacts')
  }

  async getBookingContacts(locationId) {
    return this.get(`booking-contacts`, { locationId })
  }
}
